import React from 'react'
import logo from '../assets/logo.png';
import '../styles/brand.css';

const Brand = () => {
  return (
    <div className='brandPage'>
        <div className='maintenancediv'>
            <img src={logo} alt='logo'></img>
            <h1 id='maintenancetext'>Under Maintenance,<br></br> please come back later.</h1>
        </div>
    </div>
    
  )
}

export default Brand